import {createSupplierCustomerMock, CustomerResponseBodyV2} from '@dms/api/customer';

export const suppliersMock: CustomerResponseBodyV2[] = [
  createSupplierCustomerMock('a024ebfe-b790-47b2-ac85-da86ac458869', 'Hyundai Motor Czech s.r.o.'),
  createSupplierCustomerMock(
    'c5dd0275-2599-42fb-bf9d-f657a30e1e32',
    'Mercedes-Benz Česká republika s.r.o.'
  ),
  createSupplierCustomerMock('0515d5a4-6b12-4333-8f6e-8256061d116b', 'Lesy České republiky, s.p.'),
  createSupplierCustomerMock('dba858f2-2b10-4efa-a4df-30f8f48ffccf', 'ADRIA GOLD, s.r.o.'),
  createSupplierCustomerMock('9439899f-5df6-4a40-8e64-62181760fc4c', 'MADETA a. s.'),
  createSupplierCustomerMock('ed9f6bc5-746b-4d6b-90fd-a7ed5a06ecb8', 'E-AGEO.cz s.r.o.'),
  createSupplierCustomerMock('dc388756-74f1-44aa-8489-2c726935cf82', 'ŠkoFIN s.r.o.'),
  createSupplierCustomerMock('baad633e-2c94-44af-a3f8-46c8541fce16', 'NUEVO'),
  createSupplierCustomerMock('b5e87e96-dffc-40e0-be8d-583c82c9c998', 'Paweł Tkocz'),
  createSupplierCustomerMock(
    '38394f75-1eb5-4f9d-822c-fa4d8d6921be',
    'Hyundai Motor Czech s. r. o., organizačná zložka Slovakia'
  ),
  createSupplierCustomerMock('7c334ff6-1695-42f4-8e3a-6a6be897b28d', 'Mechanic'),
  createSupplierCustomerMock('b3183e22-bb0b-4321-9cf9-ed20ad0300e8', 'HOIT s.r.o.'),
  createSupplierCustomerMock('77d8c97c-48dd-4a8d-a2cf-a21fcce40f04', 'Martek Technologies s.r.o.'),
  createSupplierCustomerMock(
    '755a2749-071e-4c9c-8404-b269a4968477',
    'Albert Česká republika, s.r.o.'
  ),
  createSupplierCustomerMock('f8918495-30e5-4d55-80ed-61a676a48681', 'LKQ CZ s.r.o.'),
  createSupplierCustomerMock('3194a87e-8d88-4d87-9c4b-cdbac044ee38', '1. Virtuální s.r.o.'),
];
